function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 6 4 L 6 5 L 6 27 L 6 28 L 7 28 L 25 28 L 26 28 L 26 27 L 26 5 L 26 4 L 25 4 L 7 4 L 6 4 z M 8 6 L 24 6 L 24 26 L 8 26 L 8 6 z M 10 11 L 10 13 L 12 13 L 12 11 L 10 11 z M 14 11 L 14 13 L 22 13 L 22 11 L 14 11 z M 10 15 L 10 17 L 12 17 L 12 15 L 10 15 z M 14 15 L 14 17 L 22 17 L 22 15 L 14 15 z M 10 19 L 10 21 L 12 21 L 12 19 L 10 19 z M 14 19 L 14 21 L 22 21 L 22 19 L 14 19 z"
  }));
};

export default __webpack_public_path__ + "static/media/ingredients-list.fda45927.svg";
export { SvgComponent as ReactComponent };